import { render, staticRenderFns } from "./StaffMoment.vue?vue&type=template&id=6b023506&scoped=true"
import script from "./StaffMoment.vue?vue&type=script&lang=js"
export * from "./StaffMoment.vue?vue&type=script&lang=js"
import style0 from "./StaffMoment.vue?vue&type=style&index=0&id=6b023506&prod&scoped=true&lang=css"
import style1 from "./StaffMoment.vue?vue&type=style&index=1&id=6b023506&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b023506",
  null
  
)

export default component.exports